import _ from 'lodash'
import accounting from 'accounting-js'
import store from '../store'
import * as types from '../store/types'
import slugify from 'slugify'
import pluralize from 'pluralize'

_.mixin({
    url (path) {
        return (_.preload('app.url') || '') + path
    },
    preload (key) {
        return store.getters[types.preload.getters.item](key)
    },
    preload_pull (key) {
        const preload = store.getters[types.preload.getters.item](key)

        store.commit(types.preload.mutations.forgot, key)

        return preload
    },
    uuid () {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
            var r = Math.random() * 16 | 0; var v = c === 'x' ? r : (r & 0x3 | 0x8)
            return v.toString(16)
        })
    },
    // @see https://ecommerce.shopify.com/c/ecommerce-design/t/ordinal-number-in-javascript-1st-2nd-3rd-4th-29259
    ordinal: function (n) {
        const s = ['th', 'st', 'nd', 'rd']
        const v = n % 100

        return n + (s[(v - 20) % 10] || s[v] || s[0])
    },
    // https://medium.com/@pppped/compute-an-arbitrary-color-for-user-avatar-starting-from-his-username-with-javascript-cd0675943b66
    strToHsl (str, saturation, lightness) {
        var hash = 0

        for (var i = 0; i < str.length; i++) {
            hash = str.charCodeAt(i) + ((hash << 5) - hash)
        }

        var hue = hash % 360

        return 'hsl(' + hue + ', ' + saturation + '%, ' + lightness + '%)'
    },
    plural (value) {
        return pluralize(value)
    },
    // Aaron -> Aaron's
    possession (value) {
        const plural = this.plural(value)

        if (value === plural) {
            return value + "'"
        }

        return value + "'s"
    },
    money (value, decimals = 2) {
        if (!value) value = 0

        let negative = false

        if (value < 0) {
            negative = true
            value = Math.abs(value)
        }

        value /= 100

        if (Number(Number(value).toFixed(0)) !== value) decimals = 2

        return (negative ? '-' : '') + accounting.formatMoney(value, {
            symbol: '£',
            precision: decimals
        })
    },
    slugify (string) {
        return slugify(string, {
            remove: /[*+~.()'"!:@]/g
        })
    },
    toBoolean (value) {
        if (!value) return false

        if (_.isBoolean(value)) return value

        if (value === 1 || value === '1') return true

        if (value === 0 || value === '0') return false

        return _.replace(_.trim(value.toLowerCase()), /[""'']/ig, '') === 'true'
    },
    round (value, precision = 0) {
        return +(Math.round(value + `e+${precision}`) + `e-${precision}`)
    },
    diff (object, base) {
        function changes (object, base) {
            return _.transform(object, (result, value, key) => {
                if (!_.isEqual(value, base[key])) {
                    result[key] = (_.isObject(value) && _.isObject(base[key]))
                        ? changes(value, base[key])
                        : value
                }
            })
        }

        return changes(object, base)
    },
    resolve (value) {
        return Promise.resolve(value)
    }
})
